import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './features/theme-provider.tsx'


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Note: Fix theme provider after demo */}
    <ThemeProvider>
    <App />
    </ThemeProvider>
  </StrictMode>,
)
